import simpleMenu from './view/simpleMenu.js';
import parent from './view/parent.js';

function initialize() {}

function openMenu() {
  if (typeof this.simpleMenu == 'undefined') {
    this.paremt = new parent('sidebar-container');
    this.simpleMenu = new simpleMenu({
      el: document.getElementsByClassName('sidebar-container')[0],
      menu_type: 'MarketPlaceMenu'
    });
  }
}

function closeMenu() {
  if (typeof this.simpleMenu != 'undefined') {
    this.simpleMenu.remove();
    this.paremt.remove();
    delete this.simpleMenu;
  }
}

export default {
  init: initialize,
  openSimpleMenu: openMenu,
  closeSimpleMenu: closeMenu
};
